module.exports = __webpack_public_path__ + "static/img/label-03.d6a0d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-03.png
// module id = HxWY
// module chunks = 150